import { render, staticRenderFns } from "./SimpleTextEditor.vue?vue&type=template&id=5f32b432&"
import script from "./SimpleTextEditor.vue?vue&type=script&lang=js&"
export * from "./SimpleTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTextEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports